import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
// import lodash from 'lodash';

import store from '@/store';
import globalConf from '@/config/globalConf';
import { getToken } from '@/util/token';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const axiosConfig = {
  baseURL: globalConf.axiosBaseURL,
  withCredentials: globalConf.axiosWithCredentials,
  timeout: globalConf.axiosTimeout,
  xsrfCookieName: globalConf.xsrfCookieName,
  xsrfHeaderName: globalConf.xsrfHeaderName,
};

const instance = axios.create(axiosConfig);

instance.interceptors.request.use((config) => {
  const conf = config;
  conf.headers[globalConf.tokenHeaderName] = getToken();
  return conf;
}, error => Promise.reject(error));

instance.interceptors.response.use((response) => {
  // session expried redirect login
  const configURL = response.config.url || '';
  const url = configURL.replace(globalConf.axiosBaseURL, '');
  if (response.data.code === 600 && !globalConf.igonreErrorURL.includes(url)) {
    Vue.prototype.$alert('会话超时，请重新登录', '会话超时', {
      type: 'warning',
      center: true,
    }).then(() => {
      store.dispatch('clearStorage');
      store.dispatch('doTimeoutLogout').then(() => {
        window.location.href = globalConf.indexPage;
      });
    });
  }
  // common message
  const msg = `温馨提示： ${response.data.msg}`;
  if (response.data.code !== 0 && response.data.code !== 600) {
    Vue.prototype.$message({
      message: msg,
      type: 'info',
      duration: 3000,
      showClose: true,
    });
  }
  // XSRF-TOKEN
  // const method = response.config.method.toLowerCase();
  // if (method === 'post') {
  //   instance.get(globalConf.tokenURL).then((res) => {
  //     if (res.data.code === 0) {
  //       setXsrfCookieToken(res.data.data);
  //     }
  //   }).catch(() => {
  //   });
  // }
  return response;
}, (error) => {
  let msg = '未知错误，请刷新页面或者重新登录';
  if (error.code === 'ECONNABORTED') {
    msg = `请求时间超过${globalConf.axiosTimeout / 1000}秒，已超时取消`;
  }
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        msg = '请求错误';
        break;
      case 401:
        msg = '未授权，请登录';
        break;
      case 403:
        msg = '拒绝访问';
        break;
      case 404:
        msg = `请求地址出错: ${error.response.config.url}`;
        break;
      case 408:
        msg = '请求超时';
        break;
      case 500:
        msg = '服务器内部错误';
        break;
      case 501:
        msg = '服务未实现';
        break;
      case 502:
        msg = '网关错误';
        break;
      case 503:
        msg = '服务不可用';
        break;
      case 504:
        msg = '网关超时';
        break;
      case 505:
        msg = 'HTTP版本不受支持';
        break;
      default:
    }
    Vue.prototype.$message({
      message: msg,
      type: 'info',
      duration: 3000,
      showClose: true,
    });
  }
  return Promise.reject(error);
});

instance.formGet = (requestURL, jsonParams, config) => {
  const cfg = Object.assign(config || {}, {
    method: 'get',
    url: requestURL,
    params: jsonParams || {},
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
  return instance.request(cfg).then(res => res.data);
};

instance.formPost = (requestURL, postData, config) => {
  const cfg = Object.assign(config || {}, {
    method: 'post',
    url: requestURL,
    data: postData || {},
    headers: Object.assign({
      'Content-Type': 'application/x-www-form-urlencoded',
    }, axios.defaults.headers),
    transformRequest: data => qs.stringify(data, { arrayFormat: 'repeat' }),
  });
  return instance.request(cfg).then(res => res.data);
};

instance.jsonGet = (requestURL, jsonParams, config) => {
  const cfg = Object.assign(config || {}, {
    method: 'get',
    url: requestURL,
    params: jsonParams || {},
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
  return instance.request(cfg).then(res => res.data);
};

instance.jsonPost = (requestURL, postData, config) => {
  const cfg = Object.assign(config || {}, {
    method: 'post',
    url: requestURL,
    data: postData || {},
  });
  return instance.request(cfg).then(res => res.data);
};

// eslint-disable-next-line no-unused-vars
Plugin.install = (vue, options) => {
  // eslint-disable-next-line no-param-reassign
  Vue.axios = instance;
  Object.defineProperties(Vue.prototype, {
    $axios: {
      get() {
        return instance;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
